import React from 'react';

interface ModalOverlayProps {
  children: React.ReactNode;
  /** "dialog" for forms, "alertdialog" for confirmations */
  role?: 'dialog' | 'alertdialog';
  ariaLabelledBy?: string;
  ariaDescribedBy?: string;
  onKeyDown?: (e: React.KeyboardEvent) => void;
  /** Ref forwarded to the overlay container (for focus trap) */
  innerRef?: React.Ref<HTMLDivElement>;
  /** Zusatzklasse am Hintergrund, z. B. `admin-dialog` (Vollbild auf dem Handy, App.css). */
  className?: string;
  /** Zusatzklasse an der Hülle des Inhalts, z. B. `admin-dialog__panel`. */
  panelClassName?: string;
}

const ModalOverlay: React.FC<ModalOverlayProps> = ({
  children,
  role = 'dialog',
  ariaLabelledBy,
  ariaDescribedBy,
  onKeyDown,
  innerRef,
  className,
  panelClassName,
}) => (
  <div
    className={`fixed inset-0 flex items-center justify-center z-50 p-4 animate-fade-in${className ? ` ${className}` : ''}`}
    style={{ background: 'var(--overlay-bg)' }}
    role={role}
    aria-modal="true"
    aria-labelledby={ariaLabelledBy}
    aria-describedby={ariaDescribedBy}
    onKeyDown={onKeyDown}
    ref={innerRef}
  >
    <div className={`animate-modal-in${panelClassName ? ` ${panelClassName}` : ''}`}>
      {children}
    </div>
  </div>
);

export default ModalOverlay;
